import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import swal from "sweetalert2";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import merchants from "@/api/merchants";
import { handleError } from "@/util/errorHandler";
import { Link } from "react-router-dom";
import { dateFormatter } from "@/util/formatter";

const STATUSES = [
  {
    value: "ALL",
    label: "All",
  },
  {
    value: "PENDING",
    label: "Pending",
  },
  {
    value: "SUCCESS",
    label: "Success",
  },
  {
    value: "REJECTED",
    label: "Rejected",
  },
  {
    value: "SYNCHRONIZATION",
    label: "Synchronization",
  },
  {
    value: "ERROR",
    label: "Error",
  },
];

class MerchantRequests extends Component {
  state = {
    selectedStatus: "ALL",
  };

  renderActionButton = (cell, row) => {
    if (row.status !== "PENDING") return "No action";

    return (
      <>
        <Button onClick={() => this.approveRequest(row)}>Approve</Button>
        <Button color="primary" onClick={() => this.rejectRequest(row)}>
          Reject
        </Button>
      </>
    );
  };

  approveRequest = async row => {
    await swal({
      title: `Approve request?`,
      html: "Do you want to approve this request?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        await this.onApproveRequest(row);
      },
    });
  };

  onApproveRequest = async ({ id }) => {
    try {
      await merchants.approveMerchantRequest(id);

      swal(
        "Success",
        "Merchant request approved. Changes will be accepted soon.",
        "success",
      );
      this.table.loadAndStoreData();
    } catch (err) {
      handleError(err);
    }
  };

  rejectRequest = async row => {
    await swal({
      title: `Reject request?`,
      html: "Do you want to reject this request?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        await this.onRejectRequest(row);
      },
    });
  };

  onRejectRequest = async ({ id }) => {
    try {
      await merchants.rejectMerchantRequest(id);

      swal("Success", "Merchant request rejected.", "success");
      this.table.loadAndStoreData();
    } catch (err) {
      handleError(err);
    }
  };

  table = null;

  bindInnerTableRef = innerComponent => {
    this.table = innerComponent;
  };

  handleStatusChange = event => {
    this.setState(
      {
        selectedStatus: event.target.value,
      },
      () => {
        this.table.loadAndStoreData();
      },
    );
  };

  loadPagination = async (page = 0, size = 10, search, sort) => {
    const status =
      this.state.selectedStatus === "ALL"
        ? undefined
        : this.state.selectedStatus;
    let result = await merchants.getMerchantRequests(
      page,
      size,
      search,
      sort,
      status,
    );
    return result;
  };

  viewFormatter = (cell, row) => {
    const { id } = row;
    const pathname = `/merchant-requests/${id}`;

    return (
      <Link
        to={{
          pathname,
          state: { data: row, previousLocation: { ...this.props.location } },
        }}>
        <div>
          <i
            className="fa fa-search"
            style={{ color: "#D15050" }}
            data-cy="view-tx"
          />
        </div>
      </Link>
    );
  };

  render() {
    return (
      <Card>
        <CardHeader>Merchant requests list</CardHeader>
        <CardBody>
          <Form
            inline
            style={{
              marginBottom: ".5rem",
              justifyContent: "flex-end",
            }}>
            <FormGroup
              className="mb-2 mr-sm-2 mb-sm-0"
              style={{ paddingRight: "2rem", alignItems: "baseline" }}>
              <Label htmlFor="type" style={{ marginRight: "1rem" }}>
                <h6>Status:</h6>
              </Label>
              <Input
                type="select"
                name="status"
                id="status"
                value={this.state.selectedStatus}
                style={{
                  maxWidth: "300px",
                }}
                onChange={this.handleStatusChange}>
                {STATUSES.map(type => {
                  return (
                    <option value={type.value} key={type.value}>
                      {type.label}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
          </Form>

          <TableContainerWithLocation
            loadData={this.loadPagination}
            options={{
              defaultSortName: "id", // to change default sort order also change default arguments in API
              defaultSortOrder: "desc",
            }}
            wrappedComponentRef={this.bindInnerTableRef}>
            <BootstrapTable
              version="4"
              search
              pagination
              striped
              hover
              condensed
              remote>
              <TableHeaderColumn
                dataFormat={this.viewFormatter}
                dataField="id"
                width="60"
                dataAlign="center"
                isKey>
                View
              </TableHeaderColumn>
              <TableHeaderColumn dataSort dataField="name" width="200">
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataSort dataField="type" width="100">
                Type
              </TableHeaderColumn>
              <TableHeaderColumn
                dataSort
                dataFormat={createTime => dateFormatter(createTime)}
                dataField="createTime"
                width="160">
                Created time
              </TableHeaderColumn>
              <TableHeaderColumn dataSort dataField="address" width="200">
                Address
              </TableHeaderColumn>
              <TableHeaderColumn dataSort dataField="requestType" width="130">
                Request type
              </TableHeaderColumn>
              <TableHeaderColumn dataSort dataField="status" width="130">
                Status
              </TableHeaderColumn>
              <TableHeaderColumn
                dataFormat={this.renderActionButton}
                width="200"
                dataAlign="center">
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          </TableContainerWithLocation>
        </CardBody>
      </Card>
    );
  }
}

export default MerchantRequests;
